import { createFileRoute } from "@tanstack/react-router";
import { AssetValuations } from "@/components/AssetValuations";

function RouteComponent() {
  return <AssetValuations />;
}

export const Route = createFileRoute("/_authenticated/asset-valuations/")({
  component: RouteComponent,
  staticData: { page: "valuations" },
});
